// TODO: Add progress for personal loans
export const KRANG_COMPLETE = 'COMPLETE';
